module.exports = __webpack_public_path__ + "static/media/cypress.67a595d5.svg";